// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__3yI0G","label":"LabeledBox_label__2UyoC"};